import { FormField } from '../../type';

interface Args {
  field: FormField;
  raw: string;
}

const truthy = new Set(['1', 'true', 'on', 'yes']);

/**
 * The value a single query param prefills its field with, or `undefined` when
 * the param cannot be trusted for it - an option the select does not offer, or
 * a block type there is nothing to prefill.
 */
export const prefillValue = ({ field, raw }: Args): unknown => {
  switch (field.blockType) {
    case 'checkbox':
      return truthy.has(raw.toLowerCase());
    case 'select':
      return field.options?.some((option) => option.value === raw)
        ? raw
        : undefined;
    case 'email':
    case 'number':
    case 'text':
    case 'textarea':
      return raw;
    default:
      return undefined;
  }
};
